
export default [
    {
        path: "/Appraisal/Index",
        name: "AppraisalIndex",
        component: () => import("@/components/Appraisal/Index.vue"),
        meta: {
            name: "AppraisalIndex",
            menuTitle: "My Data",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Appraisal/Editor",
        name: "AppraisalEditor",
        component:  () => import("@/components/Appraisal/Editor.vue"),
        meta: {
            name: "AppraisalEditor",
            menuTitle :"My Data",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Warning_Letter/Index",
        name: "Warning_LetterIndex",
        component: () => import("@/components/Warning_Letter/Index.vue"),
        meta: {
            name: "Warning_LetterIndex",
            menuTitle: "Warning Letter (SP)",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Warning_Letter/Editor",
        name: "Warning_LetterEditor",
        component:  () => import("@/components/Warning_Letter/Editor.vue"),
        meta: {
            name: "Warning_LetterEditor",
            menuTitle :"Warning Letter (SP)",
            requiresAuth: true
        },
        props: true
    },    
    {
        path: "/Appraisal/Reset",
        name: "AppraisalResetIndex",
        component: () => import("@/components/Appraisal/Reset.vue"),
        meta: {
            name: "AppraisalResetIndex",
            menuTitle: "Reset",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Appraisal/IndexAll",
        name: "AppraisalIndexAllIndex",
        component: () => import("@/components/Appraisal/IndexAll.vue"),
        meta: {
            name: "AppraisalIndexAllIndex",
            menuTitle: "List (have been assessed)",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Appraisal/Promotion",
        name: "AppraisalPromotionIndex",
        component: () => import("@/components/Appraisal/Promotion.vue"),
        meta: {
            name: "AppraisalPromotionIndex",
            menuTitle: "Promotion Request",
            requiresAuth: true
        },
        props: true
    }   
]